"use client";

import { Box } from "@mui/system";
import React from "react";
import {BasicInfoMultipleCtas} from "@/types/dto/common/basic-info";
import HubspotFormShell from "@/components/forms/hubspot-form-shell-module/hubspot-form-shell";
import { resolveLandingPageSectionBackgroundColor } from "@/utils/landing-page-background";

export interface MediaCardsSectionProps {
  basicInfo: BasicInfoMultipleCtas;
  backgroundColor?: string;
  moduleRankingPosition: string;
  moduleId?: string;
}

const MediaCardsSection = ({
  basicInfo,
  backgroundColor,
  moduleRankingPosition,
  moduleId
}: MediaCardsSectionProps) => {
  const resolvedBackgroundColor = resolveLandingPageSectionBackgroundColor(backgroundColor);

  // use first cta that has ctaType hubspotFormWithCta
  const hubspotForm = basicInfo.ctas?.find(
    (cta) => (cta.ctaType === "hubspotFormWithCta")
  )?.hubspotFormInfo;

  if (!hubspotForm) return null;

  return (
    <Box
      component="section"
      data-module-name="Hubspot Form"
      data-parent-container-type="hubspot-form-shell-section"
      data-ranking-algorithm="manual"
      data-module-ranking-position={moduleRankingPosition}
      data-track="visibility"
      data-testid="hubspot-form-shell-section"
      sx={{
        backgroundColor: resolvedBackgroundColor,
        padding: {
          xs: "4rem 2.4rem",
          lg: "6rem 10rem"
        },
        display: "flex",
        justifyContent: "center"
      }}
    >
      <HubspotFormShell
        headerText={basicInfo.headerText ?? ""}
        copyText={basicInfo.copyText}
        form={hubspotForm}
        backgroundColor={backgroundColor}
        moduleId={moduleId}
      />
    </Box>
  );
};

export default MediaCardsSection;
